import { ampli } from '@Analytics/ampli'
import { initializeApollo } from '@Globals/Apollo'
import CustomersGlobalsQuery from '@Queries/customers/Globals.query'

export async function identify({
  customerID,
  email,
  skipAmpliAwait,
}: {
  customerID?: string
  email?: string
  skipAmpliAwait?: boolean
}) {
  if (!customerID && !email) {
    throw new Error('[user] identify: either customerID or email must be defined')
  }

  let id = customerID

  if (email && !customerID) {
    const apolloClient = initializeApollo()

    const response = await apolloClient.query({
      query: CustomersGlobalsQuery,
      variables: {
        email,
      },
    })

    id = response.data?.customer?.id
  }

  if (!id) {
    return id
  }

  try {
    if (skipAmpliAwait) {
      ampli.identify(id)
    } else {
      await ampli.identify(id).promise
    }

    return id
  } catch (error) {
    return id
  }
}
